export const CRUD_ACTION_ICON_SIZE = 18;
export const CRUD_ACTION_ICON_STROKE = 1.75;
